
import './App.css';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './pages';
import About from './pages/about';
import Posts from './pages/posts';
import Queue from './pages/queue';
import Checkin from './pages/checkinSimple';
import Admin from './pages/admin';
import LoginRedirect from './pages/loginRedirect';
import SelectClient from './pages/SelectClient';
//import SelectPlan from './pages/selectPlan';
import SelectProduct from './components/LemonSqueezySelectProduct.jsx';

import AuthProvider from "./hooks/authProvider";

import PrivateRoute from "./router/privateRoute.js";
import AuthGuard from "./router/authGuard.js";

import { ClientContextProvider } from './context/ClientContext.tsx';
import "@aws-amplify/ui-react/styles.css";

import CheckoutStatus from "./pages/checkoutStatus.jsx";



function App() {
  return (
    <ClientContextProvider>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/login' element={<LoginRedirect />} />
            <Route path='/posts' element={<Posts />} />
            <Route path="/loginRedirect" element={<LoginRedirect />} />

            <Route element={<PrivateRoute />}>
              <Route path='/queue' element={<Queue />} />
            </Route>

            <Route element={<PrivateRoute />}>
              <Route path='/admin' element={<Admin />} />
            </Route>

            {/* <Route element={<PrivateRoute />}>
              <Route path='/select-client' element={<SelectClient />} />
            </Route> */}

            <Route element={<PrivateRoute />}>
              <Route path='/checkin' element={<Checkin />} />
            </Route>

            <Route element={<AuthGuard />}>
              {/* <Route path='/select-plan' element={<SelectPlan />} /> */}
              <Route path='/select-client' element={<SelectClient />} />
              <Route path="/select-plan" element={<SelectProduct />} />
              <Route path="/checkout-status" element={<CheckoutStatus />} />
            </Route>


          </Routes>
        </AuthProvider>
      </Router>
    </ClientContextProvider>


  );
}

export default App;
